import { PROPOSED_PICKUP_SELECTED, PROPOSED_PICKUP_SCHEDULED } from '../../actions/proposedPickup';

export const initialState = {
  proposedPickUpSelected: false,
  proposedPickUpScheduled: false,
};

export default (state = initialState, { type, data } = {}) => {
  switch (type) {
    case PROPOSED_PICKUP_SELECTED:
      return {
        ...state,
        proposedPickUpSelected: data,
      };
    case PROPOSED_PICKUP_SCHEDULED:
      return {
        ...state,
        proposedPickUpScheduled: data,
      };
    default:
      return state;
  }
};
